import { render, staticRenderFns } from "./lazyblock_card_slideshow.vue?vue&type=template&id=42032fb1&scoped=true"
import script from "./lazyblock_card_slideshow.vue?vue&type=script&lang=js"
export * from "./lazyblock_card_slideshow.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_card_slideshow.vue?vue&type=style&index=0&id=42032fb1&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_card_slideshow.vue?vue&type=style&index=1&id=42032fb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42032fb1",
  null
  
)

export default component.exports